// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'orders';

const Model = class Order extends BaseModel {
  static modelName = 'Order';

  static instanceDefaults() {
    return {
      purchaseOrderNo: '',
      salesOrderNo: '',
      pricing: '',
      status: '',
      deliveryDate: '',
      requestedCompletionDate: moment().add(14, 'days').format('YYYY-MM-DD'),
      expectedCompletionDate: moment().add(14, 'days').format('YYYY-MM-DD'),
      shippedDate: '',
      deliverySpeed: '',
      forwardingOption: '',
      forwarder: '',
      shippingAddress: {},
      billingAddress: {},
      orderItems: [

      ],
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
